import { memberApiV2 } from '@lib/api';
import {
  GetMedicalRecordsParams,
  IMedicalRecord,
  IMedicalRecordsRes,
} from 'types/medicalRecord.types';

/**
 * Add medical record from doctor
 * @param formData form data containing medicalRecordFile,  name, dateOfMedicalRecord
 * @param clientId id of client
 * @returns
 */
export function addMedicalRecord(providerId: string, clientId: string, formData: FormData) {
  return memberApiV2.request('/management/private/medical-data/medical-record', {
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data', 'provider-id': providerId },
    data: formData,
    params: { clientId },
  });
}

/**
 * Get list of patients medical records
 */
export function getMedicalRecords(providerId: string, params: GetMedicalRecordsParams) {
  return memberApiV2.request<{ data: IMedicalRecordsRes }>(
    '/management/private/medical-data/medical-record',
    {
      method: 'GET',
      params,
      headers: {
        'provider-id': providerId,
      },
    },
  );
}

/**
 * Get list of patients medical records
 */
export function removeMedicalRecord(providerId: string, clientId: string, id: string) {
  return memberApiV2.request(`/management/private/medical-data/medical-record/${id}`, {
    method: 'DELETE',
    params: { clientId },
    headers: {
      'provider-id': providerId,
    },
  });
}

export function getMedicalRecordById(providerId: string, clientId: string, id: string) {
  return memberApiV2.request<{ data: IMedicalRecord }>(
    `/management/private/medical-data/medical-record/${id}`,
    {
      method: 'GET',
      params: { clientId },
      headers: {
        'provider-id': providerId,
      },
    },
  );
}
